import http from '../../../service/axios';
import { IAddToBasket, IRemoveFromBasket } from '../types/Basket';
import { CalculateCartRequest } from '../types/CalculateCart';
import { ICreateOrder, ICreateOrderResponse } from '../types/CreateOrder';

export const basketAPI = {
  getDeliveryDetail: async (
    branch_id: number,
    totalSum: number,
    address_id?: string
  ) =>
    await http.get(`/branch/delivery3`, {
      params: {
        branch_id,
        totalSum,
        address_id,
      },
    }),
  createOrder: async (body: ICreateOrder) =>
    await http.post<ICreateOrderResponse>('/order/create', {
      ...body,
      branch_id: body.branch_id,

      src: 'TELEGRAM',
    }),
  calculateCart: async (body: CalculateCartRequest, signal?: AbortSignal) =>
    await http.post('/mb/calculate-cart', {
      ...body,
      branch_id: body.branch_id,
      src: 'TELEGRAM',
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
      signal,
    }),
  basketView: async ({
    telegram_id,
    branch_id,
  }: {
    telegram_id: string;
    branch_id: number;
  }) =>
    await http.post('/cart/view', {
      telegram_id,
      branch_id,
    }),
  addToBasket: async (body: IAddToBasket) => await http.post('/cart/add', body),
  removeFromBasket: async (body: IRemoveFromBasket) =>
    await http.post(`/cart/remove`, body),
  clearBasket: async ({
    telegram_id,
    productIds,
  }: {
    telegram_id: number;
    productIds?: number[];
  }) =>
    await http.post('/cart/clear', { telegram_id, product_ids: productIds }),
};
